import { TYPE } from '../../constants'
import { GtmTasksClickModel } from '../../models'
import { BaseBuilder } from '../base.builder/base.builder'

export class TasksClickBuilder extends BaseBuilder {
  constructor(data) {
    const models = new Map([[TYPE.GTM_4, GtmTasksClickModel]])
    super(models, data)
  }
}
